"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPayloadByUuid = exports.findPayloadT = exports.findPayload = exports.findItemT = exports.findItem = exports.findR = exports.findIndex = exports.find = void 0;
var maybe_adapter_1 = require("@execonline-inc/maybe-adapter");
var piper_1 = require("@kofno/piper");
var maybeasy_1 = require("maybeasy");
var taskarian_1 = require("taskarian");
var predicates_1 = require("./predicates");
var take_1 = require("./take");
function find(fn, ts) {
    var runFind = function (ts) {
        for (var _i = 0, ts_1 = ts; _i < ts_1.length; _i++) {
            var t = ts_1[_i];
            if (fn(t)) {
                return maybeasy_1.just(t);
            }
        }
        return maybeasy_1.nothing();
    };
    return typeof ts === 'undefined' ? runFind : runFind(ts);
}
exports.find = find;
function findIndex(fn, ts) {
    var runFindIndex = function (ts) {
        var idx = ts.findIndex(fn, ts);
        return idx === -1 ? maybeasy_1.nothing() : maybeasy_1.just(idx);
    };
    return typeof ts === 'undefined' ? runFindIndex : runFindIndex(ts);
}
exports.findIndex = findIndex;
var findR = function (fn) { return function (ts) { return maybe_adapter_1.toResult({ kind: 'nothing-found' }, find(fn, ts)); }; };
exports.findR = findR;
function findItem(id, items) {
    var finder = function (items) { return take_1.first(items.filter(predicates_1.byId(id))); };
    return items ? finder(items) : finder;
}
exports.findItem = findItem;
function findItemT(id, items) {
    var task = function (items) {
        return new taskarian_1.default(function (reject, resolve) {
            findItem(id, items).cata({
                Just: function (v) { return resolve(v); },
                Nothing: function () { return reject({ kind: 'item-not-found', id: id }); },
            });
            return piper_1.noop;
        });
    };
    return items ? task(items) : task;
}
exports.findItemT = findItemT;
function findPayload(id, items) {
    var finder = function (ts) { return take_1.first(ts.filter(predicates_1.byPayloadId(id))); };
    return typeof items === 'undefined' ? finder : finder(items);
}
exports.findPayload = findPayload;
function findPayloadT(id, items) {
    var task = function (items) {
        return new taskarian_1.default(function (reject, resolve) {
            findPayload(id, items).cata({
                Just: function (v) { return resolve(v); },
                Nothing: function () { return reject({ kind: 'payload-not-found', id: id }); },
            });
            return piper_1.noop;
        });
    };
    return items ? task(items) : task;
}
exports.findPayloadT = findPayloadT;
function findPayloadByUuid(uuid, items) {
    var finder = function (things) { return take_1.first(things.filter(predicates_1.byPayloadUuid(uuid))); };
    return typeof items === 'undefined' ? finder : finder(items);
}
exports.findPayloadByUuid = findPayloadByUuid;
